import { render, staticRenderFns } from "./FeedItemContainer.vue?vue&type=template&id=ab360092&"
import script from "./FeedItemContainer.vue?vue&type=script&lang=js&"
export * from "./FeedItemContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports